<template lang="pug">
router-view#app.v-application(name="drive")
</template>

<script lang="ts">
import Vue from "vue"

export default Vue.extend({
  name: "AppContainer",
})
</script>
